module.exports = __webpack_public_path__ + "media/packs/images/flags/SL-dd1779a79bd1a054526ca5c04f8923bd.png";